export class CSPError extends Error {
  public status: number

  public serializable: boolean

  public type: string

  public blockedURI: string

  public effectiveDirective: string

  public violatedDirective: string

  public referrer: string

  public originalPolicy: string

  constructor(cspViolationEvent: SecurityPolicyViolationEvent) {
    super('Content Security Policy violation')
    this.name = 'CONTENT_SECURITY_POLICY_ERROR'
    this.type = 'CONTENT_SECURITY_POLICY_ERROR'
    this.status = 403
    this.serializable = true

    this.blockedURI = cspViolationEvent.blockedURI
    this.effectiveDirective = cspViolationEvent.effectiveDirective
    this.violatedDirective = cspViolationEvent.violatedDirective
    this.referrer = cspViolationEvent.referrer
    this.originalPolicy = cspViolationEvent.originalPolicy
  }
}
